import passwordResetApi from "../../api/Alumno/passwordReset";
import { message } from "antd"

export default {
    forgotPasswordEgresado: async (data) => {
        const response = await passwordResetApi.forgotPasswordEgresado(data)
        if (!response.success)
            message.error(response.message)
        return response

    },
    recoveryPassEgresado: async (data) => {
        const response = await passwordResetApi.resetPasswordEgresado(data)
        if (!response.success)
            message.error(response.message)
        return response
    },
    confirmAccountEgresado: async (data) => {
        const response = await passwordResetApi.confirmAccountEgresado(data)
        if (!response.success)
            message.error(response.message)
        return response
    },
    onResendTokenByConfirmAccount: async (data) => {
        const response = await passwordResetApi.onResendTokenByConfirmAccount(data)
        if (!response.success)
            message.error(response.message)
        return response
    },
    onResendToken: async (data) => {
        const response = await passwordResetApi.onResendToken(data)
        if (!response.success)
            message.error(response.message)
        return response
    },
    validateTokenEgresado: async (data) => {
        const response = await passwordResetApi.validateTokenEgresado(data)
        if (!response.success){
            message.error(response.message)
        }
        return response
    },
}